import _ from "lodash";
import {
  Component,
} from "react";
import {
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  patchPrefix,
  setupAntragPanels,
} from "App/shk-form-tab";
import {
  subpanels as subpanels_lbvstatus,
} from "App/person-lbvstatus-tab";
import {
  ROLLEN,
} from "App/constants";

const panels = _.cloneDeep([...subpanels_lbvstatus]);
const mapping = [{ endpoint: "/api/shkperson/lbvstatus", prop: "antrag_lbvstatus", pfrom: "lbs_", pto: "als_" }];
setupAntragPanels(panels, mapping);
const panelStudium = panels.find(x => x.key == "studium");
patchPrefix(panelStudium.schema.table, "psb_", "asb_");


const injects = _.flatMap(panels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@store(...injects, "user")
@antragApi.current
export default class AntragLBVStatusTab extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { currentAntrag, user } = this.props;
    if (!currentAntrag) {
      return <Spinner />;
    }
    // Für Sachb alle Hilfstexte herausfiltern
    if (user.ro_id != ROLLEN.ROLLE_ANTRAGSTELLER) {
      _.map(panels, p => p.schema.table = p.schema.table.filter(f => f.type != "plaintext"));
    }
    return <SHKFormTab
      readonly args={{ a_id: currentAntrag.a_id }}
      subpanels={panels}
      injects={selectInjects(this.props)} />;
  }
}
